import styled from "styled-components";

export const StepWrapper = styled.div`
  display: flex;
  ${({ column }) => `flex-direction: ${column ? "column" : "row"}`};
  width: 100%;
`;
